module.exports = __webpack_public_path__ + "static/media/earthTooltip_icon.6e0b92b8.svg";